import { useMemo } from "react";
import { useCustomerManagementStore } from "./store";
import {
  getIsKYCDocumentStatusPending,
  getIsKYCDocumentStatusSuccess,
} from "_helpers";
import { CustomerManagementKYCDocumentsStatusEnum } from "_constants";

export const useKYCStatus = () => {
  const {
    customerManagement: { onboardingStatusDetails },
  } = useCustomerManagementStore();

  const { isBlocked, isPending, isVerified, isFirstTime } = useMemo(() => {
    const isPending = getIsKYCDocumentStatusPending(
      onboardingStatusDetails?.kycDocumentStatus
    );

    const isVerified = getIsKYCDocumentStatusSuccess(
      onboardingStatusDetails?.kycDocumentStatus
    );

    const isBlocked =
      onboardingStatusDetails?.kycDocumentStatus ===
      CustomerManagementKYCDocumentsStatusEnum.Blocked;

    const isFirstTime =
      onboardingStatusDetails?.kycDocumentStatus ===
      CustomerManagementKYCDocumentsStatusEnum.PendingUpload;

    return { isBlocked, isVerified, isPending, isFirstTime };
  }, [onboardingStatusDetails?.kycDocumentStatus]);

  return {
    isVerified,
    isPending,
    isBlocked,
    isFirstTime,
  };
};
